import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import _ from 'lodash';
import langHelper from '@/services/lang';
import store from '@/store';

export default {
  handle(data) {
    let i18n = langHelper(store.state.langSelected.langIso);
    let timeout = 6000;
    let result = i18n.t('global.error.500');
    if (typeof data !== 'undefined') {
      if (typeof data.error !== 'undefined') {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: data.error,
          type: 'error',
          doNotTranslate: true,
          timeout: timeout
        });
        result = data.error;
      } else if (typeof data.errors !== 'undefined') {
        if (_.isArray(data.errors)) {
          _.each(data.errors, (value, key) => {
            EventBus.$emit(keys.eventOnShowNotification, {
              title: '',
              message: `${value} (${key})`,
              type: 'error',
              doNotTranslate: true,
              timeout: timeout
            });
            result = `${value} (${key})`;
          });
        } else {
          EventBus.$emit(keys.eventOnShowNotification, {
            title: '',
            message: data.errors,
            type: 'error',
            doNotTranslate: true,
            timeout: timeout
          });
          result = data.error;
        }
      } else {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'global.error.500',
          type: 'error',
          doNotTranslate: false,
          timeout: timeout
        });
      }
    } else {
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: 'global.error.500',
        type: 'error',
        doNotTranslate: false,
        timeout: timeout
      });
    }
    return result;
  }
};
